import React from 'react';
import { Page } from '@wix/design-system';
import s from '../pages.scss';
import { CenteredLoader } from '../../components/centered-loader';
import { FetcherDecorator } from '../../decorators/fetcher-decorator';
import { useEssentials } from '../../contexts/essentials-context';
import { useSiteContext } from '../../contexts/site-context';
import { getAppPageData } from './app-page-api';
import { AppNotification } from './app-page-sections/notifications/app-notification';

export interface AppPageProps {
  slug: string;
}

export function AppPage({ slug }: AppPageProps) {
  const { httpClient, rpcClient } = useEssentials();
  const siteContext = useSiteContext();

  return (
    <Page className={s.appMarketPage}>
      <Page.Content>
        <FetcherDecorator
          initialFetch={() =>
            getAppPageData({
              httpClient,
              rpcClient,
              slug,
              editorType: siteContext?.editorType,
            })
          }
          loader={<CenteredLoader />}
          memoId="app-page"
        >
          {({ data: appPageData }) => {
            const { notification } = appPageData;
            return <AppNotification notification={notification} />;
          }}
        </FetcherDecorator>
      </Page.Content>
    </Page>
  );
}
